<button type="button" class="info-button" [ngbPopover]="popTemplate"
        placement="auto" [container]="container() || null"
        triggers="mouseenter" [popoverClass]="'info-popover text-center'">
  <i class="fa-solid fa-circle-chevron-up"></i>
</button>

<ng-template #popTemplate>There are {{+campaignEmailInfluencerCount() > +newInfluencerCount() ? campaignEmailInfluencerCount() : newInfluencerCount()}} more influencers in the same segment of this campaign who can be reached out too. Click re-launch (It will only target new influencers).
  <button type="button" (click)="relaunch()" class="btn btn-default btn-sm card-button active-btn">Re-launch</button>
</ng-template>
